import { CurrencyType } from "../../../common/enums";
import { IStatisticDetailedItemViewModel } from "../models/statisticDetailedItemViewModel";

export interface IDepositAmountWithCurrency {
  // SIGNED amount, expressed in `currencyId`.
  amount: number;
  currencyId: CurrencyType;
}

// Resolves the displayable amount of a deposit statistics row following the
// house currency pattern: `pricePaid` carries the raw signed value in the
// row's own currency (`currencyId`, null/undefined read as EUR), while
// `pricePaidInEur` is the EUR-normalized value used as fallback when the raw
// pair is absent (e.g. debtor balances, which stay EUR numbers by contract).
// Returns null when the row carries no amount at all.
export const getDepositAmountWithCurrency = (
  item: IStatisticDetailedItemViewModel,
): IDepositAmountWithCurrency | null => {
  if (item.pricePaid != null) {
    return {
      amount: item.pricePaid,
      currencyId: (item.currencyId ?? CurrencyType.EUR) as CurrencyType,
    };
  }

  if (item.pricePaidInEur != null) {
    return { amount: item.pricePaidInEur, currencyId: CurrencyType.EUR };
  }

  return null;
};
